import { render, staticRenderFns } from "./visit-admin.vue?vue&type=template&id=32a2acbc"
import script from "./visit-admin.vue?vue&type=script&lang=ts"
export * from "./visit-admin.vue?vue&type=script&lang=ts"
import style0 from "./visit-admin.vue?vue&type=style&index=0&id=32a2acbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports